import React from 'react';
import BaseForm from '../../../../components/form/BaseForm';
import Img from '../../../../components/Img/Img';
import Anchor from '../../../../components/link/Anchor';
import OpenUserDetail from '../../../../components/link/OpenUserDetail';
import InfoForm from '../../../../components/outline/InfoForm';
import Rate from '../../../../components/utils/Rate/Rate';
import Slider from '../../../../components/utils/Slider';
import { REVIEW_STATUS_TEXT } from '../../../account/user/detail/AccountUserDetailCsReviewInfo/constants';
import { CS_REVIEW_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { setDash, setDetailPageUrl } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import './OrderReviewInfo.scss';

const OrderReviewInfo = (props) => {
  const { reviewInfo } = props;

  if (!reviewInfo) return null;

  const {
    reviewId,
    attachments = [],
    rate,
    createDate,
    buyerId,
    userId,
    buyerName,
    content,
    status,
    orderItemId,
  } = reviewInfo;
  return (
    <div className="order-detail-content order-review-info">
      <div className="review-images">
        <Slider
          className="review-images-slider"
          emptyText="첨부 이미지가 없습니다."
          list={attachments}
          item={(url) => (
            <div className="review-image">
              <Img clickAble={false} src={url} />
            </div>
          )}
        />
      </div>

      <div className="review-info">
        <InfoForm className="review-info-form">
          {/*상품 후기 ID*/}
          <BaseForm
            label="상품 후기 ID"
            content={
              <Anchor
                text={reviewId}
                isUnderLine
                color="primary"
                href={setDetailPageUrl(CS_REVIEW_DETAIL_URL_PATH, reviewId)}
                target="_blank"
              />
            }
          />

          {/*평점*/}
          <BaseForm label="평점" content={<Rate disabled value={rate} />} />

          {/*작성일*/}
          <BaseForm label="작성일" content={setDateFormat(createDate, DATE_FORMAT.YMD_HM_DASH_FORMAT)} />

          {/*상태*/}
          <BaseForm
            label="상태"
            content={
              <Anchor
                text={REVIEW_STATUS_TEXT[status]}
                isUnderLine
                color="primary"
                href={setDetailPageUrl(CS_REVIEW_DETAIL_URL_PATH, reviewId)}
                target="_blank"
              />
            }
          />

          {/*상품 주문서 ID*/}
          <BaseForm label="상품 주문서 ID" content={orderItemId} />

          {/*구매자 ID*/}
          <BaseForm label="구매자 ID" content={<OpenUserDetail text={buyerId} userId={userId} />} />

          {/*구매자명*/}
          <BaseForm label="구매자명" content={setDash(buyerName)} />

          {/*구매평*/}
          <BaseForm className="comment" label="구매평" content={content} />
        </InfoForm>
      </div>
    </div>
  );
};

export default OrderReviewInfo;
